'use strict';
const RestUtils = require('utils/RestUtils'),
    apiAppUrl = process.env.URL_API;

const SecurityServiceImpl = {

    login: function (username, password, onSuccess, onFailure) {
        var ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                onSuccess.bind(this)();
            }, function () {
                onFailure.bind(this)();
            });
        });

        ajax.open('POST', apiAppUrl + '/api/login', true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.send(JSON.stringify({
            username: username,
            password: password
        }));
    },

    passwordRecovery: function (username, password, onSuccess, onFailure) {
        var ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                onSuccess.bind(this)();
            }, function () {
                onFailure.bind(this)(JSON.parse(this.responseText));
            });
        });

        ajax.open('POST', apiAppUrl + '/passwordrecovery', true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.send(JSON.stringify({
            username: username,
            password: password
        }));
    },

    getCurrentApplicant: function (token, callback) {
        var ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                callback.bind(this)();
            });
        });

        ajax.open('GET', apiAppUrl + '/api/users/current', true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader('X-AUTH-TOKEN', token);
        ajax.send();
    }
};


module.exports = SecurityServiceImpl;



/** WEBPACK FOOTER **
 ** ./src/services/SecurityServiceImpl.js
 **/